import { LayingPatternViewer } from 'CommonScripts/layingPatternViewer';

const dayRangeInputEl: HTMLInputElement = document.getElementsByName('dayCycle')[0] as HTMLInputElement;

export class SceneTime { 
    public static readonly defaultDate: Date = new Date('2023-01-01');

    public static setTimeByMinute(minute: number): void {
        const hours = Math.floor(minute / 60);
        const minutes = minute % 60;
        this.defaultDate.setHours(hours);
        this.defaultDate.setMinutes(minutes);

        this.setDefaultTime(minute);
        LayingPatternViewer.setSceneTime(this.defaultDate);
    }

    public static setDefaultTime(minute: number): void {
        if (dayRangeInputEl) {
            dayRangeInputEl.value = `${minute}`;
        }
    }

    public static getTimeInMinutes(): number {
        if (dayRangeInputEl) {
            return parseInt(dayRangeInputEl.value);
        }

        return null;
    }
}

if (dayRangeInputEl) {
    dayRangeInputEl.addEventListener('input', (e: Event) => {
        const target: HTMLInputElement = e.target as HTMLInputElement;
        SceneTime.setTimeByMinute(parseInt(target.value));
    });
}